export default __webpack_public_path__ + "static/media/IMG_2920.ace2d92e.jpg";